
import { RevBreadcrumb } from '@ds/components/Breadcrumb'

export default {
  components: {
    RevBreadcrumb,
  },
  props: {
    breads: {
      type: Array,
      required: true,
    },
  },
  computed: {
    links() {
      return this.breads.map(({ title, link }) => ({ title, slug: link }))
    },
  },
}
